import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { Row, Col, Card, Button } from 'reactstrap';
import simpleLineIconsCheck from '../../../assets/img/simple-line-icons_check.png';
import simpleLineIconsError from '../../../assets/img/simple-line-icons_error.png';

interface PaymentReturnProps extends RouteComponentProps<any, any, any> {}

const PaymentReturn: React.FC<PaymentReturnProps> = () => {
  const location = useLocation();
  const history = useHistory();

  const [paymentStatus, setPaymentStatus] = useState<number | undefined>();

  const handleGoToDashboard = () => {
    history.push('/inicio');
  };

  useEffect(() => {
    if (location.pathname.includes('/pago-exitoso')) {
      setPaymentStatus(1);
    } else if (location.pathname.includes('/pago-fallido')) {
      setPaymentStatus(2);
    } else if (location.pathname.includes('/pago-pendiente')) {
      setPaymentStatus(3);
    }
  }, [location.pathname]);

  return (
    <div>
      <Card
        style={{ padding: '1rem 15rem', display: 'flex', alignItems: 'center' }}
        className='max-w-4xl mx-auto bg-white shadow-md rounded-2xl p-8'
      >
        <Row className="justify-content-center mt-3 mb-3">
          <Col sm="auto">
            <p
              style={{
                fontSize: '24px',
                fontWeight: '600',
                fontStyle: 'medium',
                marginBottom: -1,
              }}
            >
              Pago de Rematriculación
            </p>
          </Col>
        </Row>
        <>
          <img
            src={paymentStatus === 1 || paymentStatus === 3 ? simpleLineIconsCheck : simpleLineIconsError}
            alt={paymentStatus === 1 || paymentStatus === 3 ? 'check' : 'error'}
            className='img-fluid mb-4'
            style={{ maxWidth: '50px' }}
          />

          <p
            style={{
              fontWeight: 'medium',
              fontSize: 26,
              marginBottom: '0.5rem',
            }}
            className='mt-4 font-semibold'
          >
            { paymentStatus === 1
              ? 'Pago realizado exitosamente'
              : paymentStatus === 3
                ? 'Pago pendiente de acreditación'
                : 'Se detectó un problema en el proceso'
            }
          </p>
          <p
            style={{
              fontWeight: 'medium',
              fontSize: 16,
              marginBottom: '1.5rem',
            }}
            className='mt-4 font-semibold'
          >
            { paymentStatus === 1
              ? 'Tu rematriculación quedó registrada correctamente.'
              : paymentStatus === 3
                ? 'Tu pago está siendo procesado. Una vez acreditado tu rematriculación quedará registrada.'
                : 'Hubo un problema con el pago. Por favor, intentá nuevamente más tarde.'
            }
          </p>
          <Button
            className='btn-custom'
            style={{ marginTop: '10rem' }}
            color='primary'
            onClick={handleGoToDashboard}
          >
            Inicio
          </Button>
        </>
      </Card>
    </div>
  );
};

export default PaymentReturn;
